export default "__VITE_ASSET__bd6c8a65__"